import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BasketEntry, FulfillmentByEntry} from '@kion/data-models';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NetworkPartnerChooseDialogComponent} from "../../dialogs/network-partner-choose-dialog/network-partner-choose-dialog.component";

@Component({
  selector: 'kion-basket-list',
  templateUrl: './basket-list.component.html',
  styleUrls: ['./basket-list.component.scss']
})
export class BasketListComponent {

  @Input() entries: BasketEntry[];
  @Input() editable = true;
  @Input() networkPartner: FulfillmentByEntry;
  @Input() isMultiVendor? = false;
  // tslint:disable-next-line:no-output-rename
  @Output('quantityChanged') quantityChangedEmitter: EventEmitter<{ entryNumber: number, quantity: number }> = new EventEmitter<{ entryNumber: number, quantity: number }>();
  // tslint:disable-next-line:no-output-rename
  @Output('delete') deleteEntryEmitter: EventEmitter<number> = new EventEmitter<number>();

  constructor(private ngbModal: NgbModal) {
  }

  quantityChanged(quantity: { entryNumber: number, quantity: number }) {
    this.quantityChangedEmitter.emit(quantity);
  }

  delete(entryNumber: number) {
    this.deleteEntryEmitter.emit(entryNumber);
  }

  showNetworkPartnerDialog() {
    const dialogRef = this.ngbModal.open(NetworkPartnerChooseDialogComponent, {
      windowClass: 'network-partner-modal'
    });
    dialogRef.componentInstance.currentFulfillmentPartner = this.entries[0]?.fulfillmentBy
  }

}
